<template>
  <div class="card mb-5">
    <div class="card-body">
      <form :action="formAction" method="post" accept-charset="UTF-8">
        <input type="hidden" name="_method" value="patch">
        <input type="hidden" name="authenticity_token" :value="csrfToken">
        <div class="mb-4">
          <div class="form-check">
            <input type="radio" class="form-check-input" name="mix-or-song" id="mix-or-song-mix" value="mix" v-model="mixOrSong">
            <label class="form-check-label" for="mix-or-song-mix">Edit version #{{ mix.version }} of <i>{{ mix.song_name }}</i></label>
          </div>
          <div class="form-check">
            <input type="radio" class="form-check-input" name="mix-or-song" id="mix-or-song-song" value="song" v-model="mixOrSong">
            <label class="form-check-label" for="mix-or-song-song">Edit all versions of <i>{{mix.song_name}}</i></label>
          </div>
        </div>

        <div class="mb-3" v-if="mixOrSong == 'mix'">
          <label class="form-label">Version Number</label>
          <input type="number" name="version" :value="version" class="form-control" min="1">
          <div class="form-text">Changing the version will cause other versions to be renumbered.</div>
        </div>

        <div class="mb-3" v-if="mixOrSong == 'mix' && otherMixes.length > 0">
          <label class="form-label">Copy Markers From Version</label>
          <select name="copy_markers_from_mix_id" class="form-select" v-model="copyMarkersFromMixId">
            <option value="">— keep existing markers —</option>
            <option v-for="m in otherMixes" :key="m.id" :value="m.id">
              Version #{{ m.version }} ({{ m.marker_count }} marker{{ m.marker_count === 1 ? '' : 's' }})
            </option>
          </select>
          <div class="form-text text-warning" v-if="copyMarkersFromMixId">This will replace all existing markers.</div>
        </div>

        <label class="form-label w-100">Artist Name
          <autocomplete
            ref="artistAutocomplete"
            :search="searchArtists"
            :default-value="currentArtistName"
            @input="onArtistInput"
            @submit="onArtistSubmit"
          />
          <input type="hidden" name="artist_name" :value="currentArtistName">
        </label>

        <label class="form-label w-100">Song Title
          <autocomplete
            :search="searchSongs"
            :default-value="mix.song_name"
            :get-result-value="getSongResultValue"
            @input="onSongInput"
            @submit="onSongSubmit"
          >
            <template #result="{ result, props }">
              <li v-bind="props">
                {{ result.name }}
                <span class="text-muted ms-2">— {{ result.artist_name }}</span>
              </li>
            </template>
          </autocomplete>
          <input type="hidden" name="song_name" :value="currentSongName">
        </label>

        <template v-if="needsMergeConfirm">
          <div class="alert alert-danger">
            Warning: the song "{{ currentSongName }}" by "{{ currentArtistName }}" already exists.
            Mixes will be merged into the existing song. Please confirm you want to do this.
            <input type="hidden" name="confirm_merge" value="1">
          </div>
          <button type="submit" class="btn btn-danger">Merge Songs</button>
        </template>
        <template v-else>
          <button type="submit" class="btn btn-primary">Save Mix</button>
        </template>
      </form>
    </div>
  </div>
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue'

export default {
  components: { Autocomplete },
  props: {
    mix: {required: true },
    artists: { type: Array, default: () => [] },
    songs: { type: Array, default: () => [] },
    needsMergeConfirm: { type: Boolean, default: false },
    otherMixes: { type: Array, default: () => [] },
  },
  data() {
    return {
      currentArtistName: this.mix?.artist_name,
      currentSongName: this.mix?.song_name,
      mixOrSong: this.mix ? 'mix' : 'song',
      copyMarkersFromMixId: '',
      version: this.mix.version
    }
  },
  computed: {
    formAction() {
      if ( this.mixOrSong == 'mix' ) {
        return `/mixes/${this.mix.id}`
      } else {
        return `/songs/${this.mix.song_id}`
      }
    },
    csrfToken() {
      const meta = document.querySelector('meta[name=csrf-token]')
      return meta ? meta.content : ''
    },
  },
  methods: {
    searchArtists(input) {
      return this.artists.filter(a => a.toLowerCase().includes(input.toLowerCase()))
    },
    onArtistInput(e) {
      this.currentArtistName = e.target.value
    },
    onArtistSubmit(result) {
      this.currentArtistName = result
    },
    searchSongs(input) {
      return this.songs.filter(s => s.name.toLowerCase().includes(input.toLowerCase()))
    },
    getSongResultValue(song) {
      return song ? song.name : ""
    },
    onSongInput(e) {
      this.currentSongName = e.target.value
    },
    onSongSubmit(song) {
      this.currentSongName = song.name
      if (song.artist_name !== this.currentArtistName) {
        this.$refs.artistAutocomplete.setValue(song.artist_name)
        this.currentArtistName = song.artist_name
      }
    },
  },
}
</script>
